/* TLY v3 redesign - shared gold fill for the gold bars (Claude, 2026-10-25).
   Same direction-aware fill as assets/tly-goldfill.js (gold pours in from the edge the pointer enters, drains to the edge
   it leaves, 2px lift).
   Binds .t3-gf (bar items) + .t3-btn (buttons, Steven 10-25: no gold at rest, fill on hover only), delegated, so it
   never touches the existing .tly-goldfill elements. Touch is ignored, so on phones nothing stays gold. A selected tab (.t3-sel)
   is NOT gold at rest (thin underline in CSS) and fills on hover like every other item.
   window.tlyV3.select(seg, btn) is the one way to change the gold selection in a bar (btn null = nothing selected). */
(function () {
  if (window.tlyV3) return;
  var POS = { left: 'left center', right: 'right center', top: 'center top', bottom: 'center bottom' };
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function emptySize(edge) { return (edge === 'left' || edge === 'right') ? '0% 100%' : '100% 0%'; }
  function edgeOf(el, e) {
    var r = el.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
    if (x < 0) return 'left';
    if (x > r.width) return 'right';
    if (y < 0) return 'top';
    if (y > r.height) return 'bottom';
    var d = { left: x, right: r.width - x, top: y, bottom: r.height - y }, best = 'left';
    for (var k in d) if (d[k] < d[best]) best = k;
    return best;
  }
  function setNow(el, pos, size) {
    el.style.transition = 'none';
    el.style.backgroundPosition = pos;
    if (size) el.style.backgroundSize = size;
    void el.offsetWidth;
    el.style.transition = '';
  }
  function clear(el) { el.style.backgroundSize = ''; el.style.backgroundPosition = ''; }
  function enter(el, e) {
    if (el.disabled) return;
    var edge = edgeOf(el, e);
    setNow(el, POS[edge], emptySize(edge));
    el.style.backgroundSize = '100% 100%';
    el.classList.add('is-on');
  }
  function leave(el, e) {
    if (!el.classList.contains('is-on')) return;
    var edge = edgeOf(el, e);
    setNow(el, POS[edge], '100% 100%');
    el.style.backgroundSize = emptySize(edge);
    el.classList.remove('is-on');
    if (reduce.matches) clear(el);
  }
  function goldOf(t) { return t && t.closest ? t.closest('.t3-gf,.t3-btn') : null; }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var el = goldOf(e.target);
    if (el && !el.contains(e.relatedTarget)) enter(el, e);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType === 'touch') return;
    var el = goldOf(e.target);
    if (el && !el.contains(e.relatedTarget)) leave(el, e);
  });
  // once drained, hand control back to the stylesheet (keyboard focus can fill again)
  document.addEventListener('transitionend', function (e) {
    var el = e.target;
    if (e.propertyName !== 'background-size' || !el.classList || !el.matches('.t3-gf,.t3-btn') || el.classList.contains('is-on')) return;
    el.style.transition = 'none'; clear(el); void el.offsetWidth; el.style.transition = '';
  });
  window.tlyV3 = {
    select: function (seg, btn) {
      seg.querySelectorAll('.t3-gf').forEach(function (x) {
        if (x !== btn) { x.classList.remove('t3-sel', 'is-on'); x.removeAttribute('aria-current'); clear(x); }
      });
      if (btn) { btn.classList.add('t3-sel'); clear(btn); }
    }
  };
})();
